<template>
  <div class="event-invitation">
    <NavHeaderBar :navBarTitle="$t('shared.modifyPersonalInformation')" :isShowLogo="false">
    </NavHeaderBar>
    <div class="form-item">
      <div class="label required">{{ $t('form.name') }}</div>
      <van-field v-model="invitationForm.nickname" placeholder="" :border="false" class="custom-field" />
    </div>
    <div class="form-item">
      <div class="label required">{{ $t('form.position') }}</div>
      <van-field readonly clickable name="picker" :value="invitationForm.job" label="" placeholder="" :border="false" class="custom-field" @click="handlePicker" />
    </div>
    <div class="form-item">
      <div class="label required">{{ $t('form.phone') }}</div>
      <div class="phone-inputs">
        <XuCountryCode class="country-code-field" v-model="invitationForm.countryCode" />
        <van-field v-model="invitationForm.phone" type="digit" maxlength="15" ref="phone1" class="custom-field" />
      </div>
      <div class="phone-tip">{{ $t('tips.messageTwentyThree') }}.</div>
    </div>
    <div class="bottom-buttons">
      <van-button class="save-btn" type="info" @click="handleSave">{{ $t('button.save') }}</van-button>
    </div>
    <!-- 下拉选择 -->
    <van-popup v-model="singlePicker" position="bottom">
      <van-picker show-toolbar value-key="val" :columns="singleColumn" @confirm="onSingleConfirm" @cancel="singlePicker = false" />
    </van-popup>
  </div>
</template>

<script>
import { arsAddOrUpdateEmployeeApi, arsActivityEmployeeInfoApi } from '@/api/home'
import { Toast, Notify, Dialog } from 'vant'
import { mapState } from 'vuex'
export default {
  components: {
    XuCountryCode: () => import('@/components/XuCountryCode')
  },
  deactivated () {
    this.$destroy()
  },
  data () {
    return {
      invitationForm: {
        nickname: '',
        job: '',
        phone: '',
        countryCode: ''
      },
      singlePicker: false,
      singleColumn: [
        { label: this.$t('shared.filter.shopkeeper'), value: 'Shopkeeper' },
        { label: this.$t('shared.filter.procMgr'), value: 'Proc Mgr' },
        { label: this.$t('shared.filter.salesclerk'), value: 'Salesclerk' }
      ],
      employeeId: ''
    }
  },
  computed: {
    ...mapState({
      globalData: 'globalData'
    })
  },
  activated () {
    this.singleColumn = []
    this.globalData.customerJob.forEach((subItem) => {
      this.singleColumn.push(JSON.parse(subItem.value))
    })
    this.employeeId = this.$route.query.employeeId || ''
    this.echoInfo()
  },
  methods: {
    handleSave () {
      const { nickname, job, phone, countryCode } = this.invitationForm
      if (!nickname) {
        this.$toast(this.$t('tips.messageTwentyFour'))
        return
      }
      if (!job) {
        this.$toast(this.$t('tips.messageTwentyFive'))
        return
      }
      if (!phone.length || !countryCode) {
        this.$toast(this.$t('tips.messageTwentySix'))
        return
      }
      // ... proceed with saving
      const data = {
        ...this.invitationForm,
        customerId: this.$route.query.customerId,
        id: this.employeeId
      }
      Dialog.confirm({
        title: this.$t('shared.title.prompt'),
        message: this.$t('tips.messageTwentySeven'),
        confirmButtonColor: '#007bff'
      })
        .then(() => {
          Toast.loading({
            message: this.$t('shared.loading'),
            forbidClick: true,
            duration: 0
          })
          arsAddOrUpdateEmployeeApi(data).then((res) => {
            Toast.clear()
            Notify({ type: 'success', message: this.$t('shared.success'), duration: 1500 })
            this.$router.go(-1)
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    echoInfo () {
      arsActivityEmployeeInfoApi(this.employeeId).then(res => {
        Object.keys(this.invitationForm).forEach(subItem => {
          this.invitationForm[subItem] = res.data[subItem]
        })
      })
    },
    // 下拉选择
    handlePicker (type) {
      this.singlePicker = true
    },
    // 下拉选择确认
    onSingleConfirm (value) {
      this.invitationForm.job = value.val
      this.singlePicker = false
    }
  }
}
</script>

<style lang="less" scoped>
.event-invitation {
  .form-item {
    padding: 0 10px;
    margin-bottom: 13px;
    &:nth-child(2) {
      margin-top: 60px;
    }
    .label {
      font-size: 12px;
      color: #333;
      margin-bottom: 8px;
      // 添加必填标记样式
      &.required {
        position: relative;
        padding-left: 12px; // 为星号预留空间
        &::before {
          content: '*';
          color: #ff4444;
          position: absolute;
          left: 0;
          top: 0;
          font-size: 14px;
          line-height: 1;
        }
      }
    }
    .custom-field {
      padding: 5px 10px;
      background: #fff;
      border: 1px solid #b9cbed;
      border-radius: 4px;
      &::placeholder {
        color: #999;
      }
    }
    .phone-inputs {
      display: flex;
      align-items: center;
      .custom-field {
        flex: 1;
        text-align: center;
      }
      span {
        margin: 0 5px;
      }
      .country-code-field {
        width: 100px;
        margin-right: 10px;
      }
    }
    .phone-tip {
      font-size: 12px;
      color: red;
      margin-top: 8px;
    }
  }
  .bottom-buttons {
    position: relative;
    .save-btn {
      position: fixed;
      bottom: 0;
      width: 100%;
    }
  }
}
</style>
